import { Menu, MenuItem } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';

const MapLeafletLayerMenu = (props) => {
  const { open, onClose, onChange, anchorEl } = props;
  const { layerSelected } = useSelector((state) => state.map);

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: (theme) => ({
          marginTop: theme.spacing(1.25),
          '&:before': {
            right: theme.spacing(3),
          },
        }),
      }}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}>
      {config.mapLayer.map((value, key) => (
        <MenuItem key={key} disableRipple selected={layerSelected === value} onClick={() => onChange(value)}>
          {value}
        </MenuItem>
      ))}
    </Menu>
  );
};

export default MapLeafletLayerMenu;
